import React from "react";

function ReactionIcon(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      fill="none"
      viewBox="0 0 24 24"
      {...props}
    >
      <path
        fill={props.fillcolor}
        fillRule="evenodd"
        d="M12 1C5.925 1 1 5.925 1 12s4.925 11 11 11 11-4.925 11-11S18.075 1 12 1zM9.038 7.77c-.609 0-.934.472-1.056.715-.144.305-.217.639-.213.977 0 .336.067.682.213.977.122.242.446.715 1.056.715.61 0 .935-.473 1.056-.715.147-.294.214-.641.214-.977a2.22 2.22 0 00-.213-.977c-.122-.243-.446-.716-1.057-.716zm4.867.715c.122-.243.446-.716 1.056-.716.61 0 .935.473 1.056.716.147.293.214.64.214.977 0 .336-.067.682-.214.977-.121.242-.445.715-1.056.715-.609 0-.934-.473-1.056-.715a2.212 2.212 0 01-.213-.977c0-.337.067-.683.213-.977zm2.283 7.703a.848.848 0 00-.26-1.404.846.846 0 00-.936.208 4.23 4.23 0 01-5.984 0 .846.846 0 00-1.196 1.196 5.923 5.923 0 008.376 0z"
        clipRule="evenodd"
      ></path>
    </svg>
  );
}

export default ReactionIcon;
